// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2156":"d1c7cfd1","3607":"2213cff5","3657":"63549c57"}[chunkId] + ".chunk.css";
};